import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/withOthers'
import actions from '../actions/withOthers'
import shareActions from '../actions/share'
import revokeActions from '../actions/revoke'

class Container extends React.Component {

  constructor(props) {
    super(props)

    props.fetch()
  }

  render() {
    return <Component {...this.props}/>
  }
}

Container.propTypes = {
  fetch: PropTypes.func.isRequired,
  history: PropTypes.object,
}

const mapStateToProps = state => {
  const data = state.ui.shared.withOthers
  return {
    catalogs: data.get('catalogs').toArray(),
    isFetching: data.get('isFetching'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetch: () => dispatch(actions.fetch()),
    setOpenShare: open => dispatch(shareActions.setOpen(open)),
    setOpenRevoke: (open, accessId, name) => dispatch(revokeActions.setOpen(open, accessId, name)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/shared/containers/withOthers.js